import { FRACTIONS } from '@/utils/constants/drs/fractions'

export default {
    computed: {
        operatorName() {
            return this.bag.selectedOperator?.name || '---'
        },

        shouldHighlightSealPrefix() {
            return this.bag.seal_number && this.bag.selectedOperator
        },

        isOpen() {
            return !this.bag.isClosed
        },

        total() {
            return this.$options.filters.currency(this.bag.value / 100)
        },

        quantity() {
            return this.bag.quantity
        },

        fraction() {
            return Object.values(FRACTIONS).find(f => f.id === this.bag.fractionTypeId) || null
        },

        isSealNumberUnknown() {
            if (!this.sealNumber) return true

            const validSealPrefixes = this.$store.getters['drsBags/validSealPrefixes']
            return !validSealPrefixes.includes(this.sealNumber.slice(0, 2))
        },

        isSealPrefixNotPreferred() {
            if (!this.sealNumber) return true

            return this.bag.preferredOperator && this.sealNumber.slice(0, 2) !== this.bag.preferredOperator.prefix
        }
    }
}